import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import CookieService from "../../context/cookies";

import { base } from "../../constants/apis";

export const commonApi = createApi({
  reducerPath: "commonApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${base}/apis/common`,
    prepareHeaders: (headers) => {
      const token = CookieService.getCookie("jwtToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["commonApi"],
  endpoints: (builder) => ({
    fileUpload: builder.mutation({
      query: (payload) => ({
        url: "/file_upload.php",
        method: "POST",
        body: payload,
      }),
    }),

    serveFile: builder.query<{ fileUrl: string; mimeType: string }, string>({
      query: (file) => ({
        url: `/serve_file.php?file=${file}`,
        method: "GET",
        responseHandler: async (response) => {
          // This lets us manually read the body as a blob
          const blob = await response.blob();
          return {
            fileUrl: URL.createObjectURL(blob),
            mimeType: blob.type,
          };
        },
      }),
    }),
  }),
});

export const { useFileUploadMutation, useServeFileQuery } = commonApi;
